export const isVariableInLS = (key: string) => localStorage.getItem(key) === '1';
